import produce from 'immer';
import {
    SET_USER_INFO,
    SET_SELECTED_LANGUAGE,
    SET_USER_TS,
} from '../../actions/actionTypes';

export const initialOptions = {
    availableLanguages: [
        {
            DisplayName: 'English',
            Locale: 'en',
            Selected: true,
        },
    ],
    entityID: null,
    firstName: '',
    helpMenus: [],
    isAdmin: false,
    isSuperAdmin: false,
    isThiefsDownfall: false,
    lastName: '',
    MVID: '',
    photo: '',
    lastActiveTS: '',
    userID: null,
    manufacturerID: 0,
    featureFlag: {},
    hasFetchedFeatureFlag: false,
    usergroupPermissions: [],
    enableTicketID: false,
    mPlanPageTimeFilters: false,
    includePrivateResponse: false,
};

const userInfo = produce((draft, action = { type: null }) => {
    switch (action.type) {
        case SET_USER_INFO:
            return action.userInfo;
        case SET_SELECTED_LANGUAGE:
            return {
                ...draft,
                availableLanguages: draft.availableLanguages.map((lang) => ({ ...lang, Selected: lang.Locale === action.selectedLocale })),
            };
        case SET_USER_TS:
            return {
                ...draft,
                lastActiveTS: action.timestamp,
            };
    }
}, initialOptions);

export default userInfo;
